;+(function (n) {
  'use strict'
  function t() {
    var i = document.createElement('gg'),
      n = {
        WebkitTransition: 'webkitTransitionEnd',
        MozTransition: 'transitionend',
        OTransition: 'oTransitionEnd otransitionend',
        transition: 'transitionend',
      }
    for (var t in n) if (i.style[t] !== undefined) return { end: n[t] }
    return !1
  }
  n.fn.emulateTransitionEnd = function (t) {
    var i = !1,
      u = this,
      r
    n(this).one('ggTransitionEnd', function () {
      i = !0
    })
    return (
      (r = function () {
        i || n(u).trigger(n.support.transition.end)
      }),
      setTimeout(r, t),
      this
    )
  }
  n(function () {
    ;((n.support.transition = t()), n.support.transition) &&
      (n.event.special.ggTransitionEnd = {
        bindType: n.support.transition.end,
        delegateType: n.support.transition.end,
        handle: function (t) {
          if (n(t.target).is(this))
            return t.handleObj.handler.apply(this, arguments)
        },
      })
  })
})(jQuery)
;+(function (n) {
  'use strict'
  function r(i) {
    return this.each(function () {
      var u = n(this),
        r = u.data('gg.tooltip'),
        f = typeof i == 'object' && i
      ;(r || i != 'destroy') &&
        (r || u.data('gg.tooltip', (r = new t(this, f))),
        typeof i == 'string' && r[i]())
    })
  }
  var t = function (n, t) {
      this.type =
        this.options =
        this.enabled =
        this.timeout =
        this.hoverState =
        this.$element =
          null
      this.init('tooltip', n, t)
    },
    i
  t.VERSION = '2.0'
  t.TRANSITION_DURATION = 150
  t.DEFAULTS = {
    animation: !0,
    placement: 'top',
    selector: !1,
    template:
      '<div class="ggtooltip" role="tooltip"><div class="arrow-shadow"><div class="arrow"></div></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: !1,
    container: !1,
    viewport: { selector: 'body', padding: 0 },
    backcolor: '#00ffcc',
    textcolor: '#000000',
    bordercolor: '#0066cc',
  }
  t.prototype.init = function (t, i, r) {
    var f, e, u, o, s
    for (
      this.enabled = !0,
        this.type = t,
        this.$element = n(i),
        this.options = this.getOptions(r),
        this.$viewport =
          this.options.viewport &&
          n(this.options.viewport.selector || this.options.viewport),
        f = this.options.trigger.split(' '),
        e = f.length;
      e--;

    )
      if (((u = f[e]), u == 'click'))
        this.$element.on(
          'click.' + this.type,
          this.options.selector,
          n.proxy(this.toggle, this),
        )
      else if (u != 'manual') {
        o = u == 'hover' ? 'mouseenter' : 'focusin'
        s = u == 'hover' ? 'mouseleave' : 'focusout'
        this.$element.on(
          o + '.' + this.type,
          this.options.selector,
          n.proxy(this.enter, this),
        )
        this.$element.on(
          s + '.' + this.type,
          this.options.selector,
          n.proxy(this.leave, this),
        )
      }
    this.options.selector
      ? (this._options = n.extend({}, this.options, {
          trigger: 'manual',
          selector: '',
        }))
      : this.fixTitle()
  }
  t.prototype.getDefaults = function () {
    return t.DEFAULTS
  }
  t.prototype.getOptions = function (t) {
    return (
      (t = n.extend({}, this.getDefaults(), this.$element.data(), t)),
      t.delay &&
        typeof t.delay == 'number' &&
        (t.delay = { show: t.delay, hide: t.delay }),
      t
    )
  }
  t.prototype.getDelegateOptions = function () {
    var t = {},
      i = this.getDefaults()
    return (
      this._options &&
        n.each(this._options, function (n, r) {
          i[n] != r && (t[n] = r)
        }),
      t
    )
  }
  t.prototype.enter = function (t) {
    var i =
      t instanceof this.constructor
        ? t
        : n(t.currentTarget).data('gg.' + this.type)
    if (i && i.$tip && i.$tip.is(':visible')) {
      i.hoverState = 'in'
      return
    }
    if (
      (i ||
        ((i = new this.constructor(t.currentTarget, this.getDelegateOptions())),
        n(t.currentTarget).data('gg.' + this.type, i)),
      clearTimeout(i.timeout),
      (i.hoverState = 'in'),
      !i.options.delay || !i.options.delay.show)
    )
      return i.show()
    i.timeout = setTimeout(function () {
      i.hoverState == 'in' && i.show()
    }, i.options.delay.show)
  }
  t.prototype.leave = function (t) {
    var i =
      t instanceof this.constructor
        ? t
        : n(t.currentTarget).data('gg.' + this.type)
    if (
      (i ||
        ((i = new this.constructor(t.currentTarget, this.getDelegateOptions())),
        n(t.currentTarget).data('gg.' + this.type, i)),
      clearTimeout(i.timeout),
      (i.hoverState = 'out'),
      !i.options.delay || !i.options.delay.hide)
    )
      return i.hide()
    i.timeout = setTimeout(function () {
      i.hoverState == 'out' && i.hide()
    }, i.options.delay.hide)
  }
  t.prototype.show = function () {
    var c = n.Event('show.gg.' + this.type),
      l,
      p,
      h
    if (this.hasContent() && this.enabled) {
      if (
        (this.$element.trigger(c),
        (l = n.contains(
          this.$element[0].ownerDocument.documentElement,
          this.$element[0],
        )),
        c.isDefaultPrevented() || !l)
      )
        return
      var u = this,
        r = this.tip(),
        a = this.getUID(this.type)
      this.setContent()
      r.attr('id', a)
      this.$element.attr('aria-describedby', a)
      this.options.animation && r.addClass('fade')
      var i =
          typeof this.options.placement == 'function'
            ? this.options.placement.call(this, r[0], this.$element[0])
            : this.options.placement,
        v = /\s?auto?\s?/i,
        y = v.test(i)
      y && (i = i.replace(v, '') || 'top')
      r.detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(i)
        .data('gg.' + this.type, this)
      this.options.container
        ? r.appendTo(this.options.container)
        : r.insertAfter(this.$element)
      var f = this.getPosition(),
        o = r[0].offsetWidth,
        s = r[0].offsetHeight
      if (y) {
        var w = i,
          b = this.options.container
            ? n(this.options.container)
            : this.$element.parent(),
          e = this.getPosition(b)
        i =
          i == 'bottom' && f.bottom + s > e.bottom
            ? 'top'
            : i == 'top' && f.top - s < e.top
            ? 'bottom'
            : i == 'right' && f.right + o > e.width
            ? 'left'
            : i == 'left' && f.left - o < e.left
            ? 'right'
            : i
        r.removeClass(w).addClass(i)
      }
      p = this.getCalculatedOffset(i, f, o, s)
      this.applyPlacement(p, i)
      h = function () {
        var n = u.hoverState
        u.$element.trigger('shown.gg.' + u.type)
        u.hoverState = null
        n == 'out' && u.leave(u)
      }
      n.support.transition && this.$tip.hasClass('fade')
        ? r
            .one('ggTransitionEnd', h)
            .emulateTransitionEnd(t.TRANSITION_DURATION)
        : h()
    }
  }
  t.prototype.applyPlacement = function (t, i) {
    var r = this.tip(),
      l = r[0].offsetWidth,
      e = r[0].offsetHeight,
      o = parseInt(r.css('margin-top'), 10),
      s = parseInt(r.css('margin-left'), 10),
      h,
      f,
      u
    isNaN(o) && (o = 0)
    isNaN(s) && (s = 0)
    t.top = t.top + o
    t.left = t.left + s
    n.offset.setOffset(
      r[0],
      n.extend(
        {
          using: function (n) {
            r.css({ top: Math.round(n.top), left: Math.round(n.left) })
          },
        },
        t,
      ),
      0,
    )
    r.addClass('in')
    h = r[0].offsetWidth
    f = r[0].offsetHeight
    i == 'top' && f != e && (t.top = t.top + e - f)
    u = this.getViewportAdjustedDelta(i, t, h, f)
    u.left ? (t.left += u.left) : (t.top += u.top)
    var c = /top|bottom/.test(i),
      a = c ? u.left * 2 - l + h : u.top * 2 - e + f,
      v = c ? 'offsetWidth' : 'offsetHeight'
    r.offset(t)
    this.replaceArrow(a, r[0][v], c)
    this.setStyles(i)
  }
  t.prototype.replaceArrow = function (n, t, i) {
    n > 0 &&
      (this.arrow()
        .css(i ? 'left' : 'top', 50 * (1 - n / t) + '%')
        .css(i ? 'top' : 'left', ''),
      this.arrowShadow()
        .css(i ? 'left' : 'top', 50 * (1 - n / t) + '%')
        .css(i ? 'top' : 'left', ''))
  }
  t.prototype.setContent = function () {
    var n = this.tip(),
      t = this.getTitle()
    n.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](t)
    n.removeClass('fade in top bottom left right')
  }
  t.prototype.setStyles = function (n) {
    var t = this.tip()
    t.find('.tooltip-inner').css({
      background: this.options.backcolor,
      color: this.options.textcolor,
      'border-color': this.options.bordercolor,
    })
    t.find('.arrow').css('border-' + n + '-color', this.options.backcolor)
    t.find('.arrow-shadow').css(
      'border-' + n + '-color',
      this.options.bordercolor,
    )
  }
  t.prototype.hide = function (i) {
    function e() {
      r.hoverState != 'in' && u.detach()
      r.$element.removeAttr('aria-describedby').trigger('hidden.gg.' + r.type)
      i && i()
    }
    var r = this,
      u = this.tip(),
      f = n.Event('hide.gg.' + this.type)
    if ((this.$element.trigger(f), !f.isDefaultPrevented()))
      return (
        u.removeClass('in'),
        n.support.transition && this.$tip.hasClass('fade')
          ? u
              .one('ggTransitionEnd', e)
              .emulateTransitionEnd(t.TRANSITION_DURATION)
          : e(),
        (this.hoverState = null),
        this
      )
  }
  t.prototype.fixTitle = function () {
    var n = this.$element
    ;(n.attr('title') || typeof n.attr('data-original-title') != 'string') &&
      n.attr('data-original-title', n.attr('title') || '').attr('title', '')
  }
  t.prototype.hasContent = function () {
    return this.getTitle()
  }
  t.prototype.getPosition = function (t) {
    t = t || this.$element
    var u = t[0],
      r = u.tagName == 'BODY',
      i = u.getBoundingClientRect()
    i.width == null &&
      (i = n.extend({}, i, {
        width: i.right - i.left,
        height: i.bottom - i.top,
      }))
    var f = r ? { top: 0, left: 0 } : t.offset(),
      e = {
        scroll: r
          ? document.documentElement.scrollTop || document.body.scrollTop
          : t.scrollTop(),
      },
      o = r ? { width: n(window).width(), height: n(window).height() } : null
    return n.extend({}, i, e, o, f)
  }
  t.prototype.getCalculatedOffset = function (n, t, i, r) {
    return n == 'bottom'
      ? { top: t.top + t.height, left: t.left + t.width / 2 - i / 2 }
      : n == 'top'
      ? { top: t.top - r, left: t.left + t.width / 2 - i / 2 }
      : n == 'left'
      ? { top: t.top + t.height / 2 - r / 2, left: t.left - i }
      : { top: t.top + t.height / 2 - r / 2, left: t.left + t.width }
  }
  t.prototype.getViewportAdjustedDelta = function (n, t, i, r) {
    var f = { top: 0, left: 0 },
      e,
      u,
      o,
      s,
      h,
      c
    return this.$viewport
      ? ((e = (this.options.viewport && this.options.viewport.padding) || 0),
        (u = this.getPosition(this.$viewport)),
        /right|left/.test(n)
          ? ((o = t.top - e - u.scroll),
            (s = t.top + e - u.scroll + r),
            o < u.top
              ? (f.top = u.top - o)
              : s > u.top + u.height && (f.top = u.top + u.height - s))
          : ((h = t.left - e),
            (c = t.left + e + i),
            h < u.left
              ? (f.left = u.left - h)
              : c > u.width && (f.left = u.left + u.width - c)),
        f)
      : f
  }
  t.prototype.getTitle = function () {
    var t = this.$element,
      n = this.options
    return (
      t.attr('data-original-title') ||
      (typeof n.title == 'function' ? n.title.call(t[0]) : n.title)
    )
  }
  t.prototype.getUID = function (n) {
    do n += ~~(Math.random() * 1e6)
    while (document.getElementById(n))
    return n
  }
  t.prototype.tip = function () {
    return (this.$tip = this.$tip || n(this.options.template))
  }
  t.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }
  t.prototype.arrowShadow = function () {
    return (this.$arrowShadow =
      this.$arrowShadow || this.tip().find('.arrow-shadow'))
  }
  t.prototype.enable = function () {
    this.enabled = !0
  }
  t.prototype.disable = function () {
    this.enabled = !1
  }
  t.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }
  t.prototype.toggle = function (t) {
    var i = this
    t &&
      ((i = n(t.currentTarget).data('gg.' + this.type)),
      i ||
        ((i = new this.constructor(t.currentTarget, this.getDelegateOptions())),
        n(t.currentTarget).data('gg.' + this.type, i)))
    i.tip().hasClass('in') ? i.leave(i) : i.enter(i)
  }
  t.prototype.destroy = function () {
    var n = this
    clearTimeout(this.timeout)
    this.hide(function () {
      n.$element.off('.' + n.type).removeData('gg.' + n.type)
    })
  }
  i = n.fn.ggtooltip
  n.fn.ggtooltip = r
  n.fn.ggtooltip.Constructor = t
  n.fn.ggtooltip.noConflict = function () {
    return (n.fn.ggtooltip = i), this
  }
})(jQuery)
;+(function (n) {
  'use strict'
  function r(i) {
    return this.each(function () {
      var u = n(this),
        r = u.data('gg.popover'),
        f = typeof i == 'object' && i
      ;(r || i != 'destroy') &&
        (r || u.data('gg.popover', (r = new t(this, f))),
        typeof i == 'string' && r[i]())
    })
  }
  var t = function (n, t) {
      this.init('popover', n, t)
    },
    i
  if (!n.fn.ggtooltip) throw new Error('ggPopover requires ggtooltip.js')
  t.VERSION = '1.0'
  t.DEFAULTS = n.extend({}, n.fn.ggtooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template:
      '<div class="ggpopover" role="tooltip"><div class="arrow"><div class="after"></div></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
    titleBackcolor: '#f7f7f7',
    titleBordercolor: '#ebebeb',
    titleTextcolor: '#000000',
    contentBackcolor: '#ffffff',
    contentTextcolor: '#000000',
    bordercolor: '#cccccc',
    arrowcolor: '#ffffff',
  })
  t.prototype = n.extend({}, n.fn.ggtooltip.Constructor.prototype)
  t.prototype.constructor = t
  t.prototype.getDefaults = function () {
    return t.DEFAULTS
  }
  t.prototype.setContent = function () {
    var n = this.tip(),
      i = this.getTitle(),
      t = this.getContent()
    n.find('.popover-title')[this.options.html ? 'html' : 'text'](i)
    n.find('.popover-content')
      .children()
      .detach()
      .end()
      [this.options.html ? (typeof t == 'string' ? 'html' : 'append') : 'text'](
        t,
      )
    n.removeClass('fade top bottom left right in')
    n.find('.popover-title').html() || n.find('.popover-title').hide()
  }
  t.prototype.setStyles = function (n) {
    var t = this.tip(),
      i = this.getTitle()
    t.find('.popover-title').css({
      'background-color': this.options.titleBackcolor,
      color: this.options.titleTextcolor,
      'border-bottom-color': this.options.titleBordercolor,
    })
    t.find('.popover-content').css({
      'background-color': this.options.contentBackcolor,
      color: this.options.contentTextcolor,
    })
    t.find('.arrow').css('border-' + n + '-color', this.options.bordercolor)
    t.find('.arrow > .after').css(
      'border-' + n + '-color',
      this.options.arrowcolor,
    )
    t.css({ 'border-color': this.options.bordercolor })
  }
  t.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }
  t.prototype.getContent = function () {
    var t = this.$element,
      n = this.options
    return (
      t.attr('data-content') ||
      (typeof n.content == 'function' ? n.content.call(t[0]) : n.content)
    )
  }
  t.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }
  t.prototype.tip = function () {
    return this.$tip || (this.$tip = n(this.options.template)), this.$tip
  }
  i = n.fn.ggpopover
  n.fn.ggpopover = r
  n.fn.ggpopover.Constructor = t
  n.fn.ggpopover.noConflict = function () {
    return (n.fn.ggpopover = i), this
  }
})(jQuery)
/*
//# sourceMappingURL=ggpopover.min.js.map
*/
